export default __webpack_public_path__ + "static/media/mons9.23ba4eae.jpg";